<h2 mat-dialog-title>
  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
  Rediger organisation
</h2>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<form [formGroup]="dialogForm" (submit)="save()">
  <mat-dialog-content>
    <div class="form-row">
      <mat-form-field>
        <mat-label>Navn</mat-label>
        <input type="text" matInput formControlName="name" />
        @if (dialogForm.controls['name'].hasError('required')) {
          <mat-error>{{ getControlErrorMessage('name', 'required') }}</mat-error>
        }
        @if (dialogForm.controls['name'].hasError('whitespace')) {
          <mat-error>{{ getControlErrorMessage('name', 'empty') }}</mat-error>
        }
        @if (dialogForm.controls['name'].hasError('minlength')) {
          <mat-error>{{ getControlErrorMessage('name', 'minLength') }}</mat-error>
        }
        @if (dialogForm.controls['name'].hasError('maxlength')) {
          <mat-error>{{ getControlErrorMessage('name', 'maxLength') }}</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-row">
      <adm-g4-customer-number [control]="dialogForm.controls.identification" />
    </div>
    <div class="form-row">
      <mat-form-field>
        <mat-label>Type</mat-label>
        <mat-select formControlName="organizationType" okCustomDropDownArrowDirective>
          @for (enum of organizationType | keyvalue; track enum) {
            <mat-option [value]="enum.key">
              {{ enum.key | translateOrganizationType }}
            </mat-option>
          }
        </mat-select>
        <mat-icon matSuffix></mat-icon>
      </mat-form-field>
    </div>
    <div class="form-row discount">
      <mat-form-field>
        <mat-label>Rabattype</mat-label>
        <mat-select formControlName="discountType" okCustomDropDownArrowDirective>
          @for (enum of discountTypes | keyvalue; track enum) {
            <mat-option [value]="enum.key">
              {{ enum.key | translateOrganizationDiscountType }}
            </mat-option>
          }
        </mat-select>
        <mat-icon matSuffix></mat-icon>
        @if (organization?.hasAttachedAccessGroups) {
          <mat-hint class="hint" align="start"> Rabattype kan ændres på "rediger rabattype" på organisationen </mat-hint>
        }
      </mat-form-field>
    </div>
    <div class="form-row margin--bottom-l">
      <mat-slide-toggle formControlName="idTagInvitationActive" color="primary">
        <div class="flex flex-col">Må oprette brik-brugere</div>
      </mat-slide-toggle>
    </div>
    <div class="form-row organisation-logo-container">
      <div class="help-icon-wrapper">
        <mat-icon
          [matTooltip]="'Logoet bliver vist i appen som virksomhedens identitet, på ladekortet og det detaljerede overblik for visning af lokationer. Dette vil oftest vises i en circle. (Skal være png eller svg. Maks 1MB i størrelse)'">
          help_outline
        </mat-icon>
      </div>
      <mat-form-field>
        <mat-label>Kompakt logo url</mat-label>
        <input type="text" matInput formControlName="compactLogoLink" />
        @if (dialogForm.controls['compactLogoLink'].hasError('pattern')) {
          <mat-error>
            {{ getControlErrorMessage('compactLogoLink', 'pattern') }}
          </mat-error>
        }
      </mat-form-field>
      <div
        class="logo-image-container"
        [matTooltip]="'Intet logo valgt'"
        [matTooltipDisabled]="
          !dialogForm.controls['compactLogoLink'].hasError('pattern') && !!dialogForm.controls['compactLogoLink'].value
        ">
        @if (!dialogForm.controls['compactLogoLink'].hasError('pattern') && !!dialogForm.controls['compactLogoLink'].value) {
          <img class="organization-logo logo-image" [src]="dialogForm.controls['compactLogoLink'].value" />
        } @else {
          <mat-icon class="placeholder-icon">block</mat-icon>
        }
      </div>
    </div>

    <div class="form-row organisation-logo-container">
      <div class="help-icon-wrapper">
        <mat-icon
          [matTooltip]="'Logoet vises når man ser mere information om en lokation i app\'en, og bruges hvor der er mere plads til logoet. (Skal være png eller svg. Maks 1MB i størrelse)'">
          help_outline
        </mat-icon>
      </div>
      <mat-form-field>
        <mat-label>Logo url</mat-label>
        <input type="text" matInput formControlName="logoLink" />
        @if (dialogForm.controls['logoLink'].hasError('pattern')) {
          <mat-error>
            {{ getControlErrorMessage('logoLink', 'pattern') }}
          </mat-error>
        }
      </mat-form-field>
      <div
        class="logo-image-container"
        [matTooltip]="'Intet logo valgt'"
        [matTooltipDisabled]="!dialogForm.controls['logoLink'].hasError('pattern') && !!dialogForm.controls['logoLink'].value">
        @if (!dialogForm.controls['logoLink'].hasError('pattern') && !!dialogForm.controls['logoLink'].value) {
          <img class="organization-logo logo-image" [src]="dialogForm.controls['logoLink'].value" />
        } @else {
          <mat-icon class="placeholder-icon">block</mat-icon>
        }
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-dialog-close type="button" mat-button>Annuller</button>

    <button type="submit" mat-raised-button color="primary" [disabled]="dialogForm.invalid">Gem</button>
  </mat-dialog-actions>
</form>
